import bgImage from "../../../../assets/images/blog/bg.png";
import authorProfileImg from "../../../../assets/images/blog/autor-profile-img.png";
import barChart from "../../../../assets/images/blog/bar-chart.png";
import articleImg from "../../../../assets/images/blog/article-image.png";

export const blogTemplate = {
  title: 'Essential Composition: Balance',
  description: 'How do you create compelling presentations that wow your colleagues and impress your managers?',
  header_image: bgImage,
  author: {
    name: 'Jess Brown',
    description: 'Published in Category, Jan 20, 2022',
    avatar: authorProfileImg
  },
  category: "Finance",
  created_at: new Date(),
  content: [
    {
      "id": "tYJ7NQq3bj",
      "type": "paragraph",
      "data": {
        "text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ullamcorper mattis lorem non. Ultrices praesent amet ipsum justo massa. Eu dolor aliquet risus gravida nunc at feugiat consequat purus. Non massa enim vitae duis mattis. Vel in ultricies vel fringilla."
      }
    },
    {
      "id": "u8bmTozn4o",
      "type": "introduction",
      "data": {
        "text": "Mi tincidunt elit, id quisque ligula ac diam, amet. Vel etiam suspendisse morbi eleifend faucibus eget vestibulum felis. Dictum quis montes, sit sit. Tellus aliquam enim urna, etiam. Mauris posuere vulputate arcu amet, vitae nisi, tellus tincidunt. At feugiat sapien varius id.Eget quis mi enim, leo lacinia pharetra, semper. <br /> <br /> Eget in volutpat mollis at volutpat lectus velit, sed auctor. Porttitor fames arcu quis fusce augue enim. Quis at habitant diam at. Suscipit tristique risus, at donec. In turpis vel et quam imperdiet. Ipsum molestie aliquet sodales id est ac volutpat."
      }
    },
    {
      "id": "_ccAEeg5My",
      "type": "image",
      "data": {
        "file": {
          "url": barChart
        },
        "caption": "Data courtesy of Scott Webb via <a href=\"http://google.com\">This Link</a>",
        "withBorder": false,
        "stretched": false,
        "withBackground": false
      }
    },
    {
      "id": "Eh_osKSbnY",
      "type": "paragraph",
      "data": {
        "text": "Ipsum sit mattis nulla quam nulla. Gravida id gravida ac enim mauris id. Non pellentesque congue eget consectetur turpis. Sapien, dictum molestie sem tempor. Diam elit, orci, tincidunt aenean tempus. Quis velit eget ut tortor tellus. Sed vel, congue felis elit erat nam nibh orci."
      }
    },
    {
      "id": "QjfOPsGJGh",
      "type": "quote",
      "data": {
        "text": "“In a world older and more complete than ours they move finished and complete, gifted with extensions of the senses we have lost or never attained, living by voices we shall never hear.”",
        "caption": "— Bob Ross, Legendary Painter",
        "alignment": "left"
      }
    },
    {
      "id": "cAZX7hIkRF",
      "type": "email",
      "data": {
        "text": "Get 10% off your first order"
      }
    },
    {
      "id": "ZPrjsidr-I",
      "type": "paragraph",
      "data": {
        "text": "Dolor enim eu tortor urna sed duis nulla. Aliquam vestibulum, nulla odio nisl vitae. In aliquet pellentesque aenean hac vestibulum turpis mi bibendum diam. Tempor integer aliquam in vitae malesuada fringilla.Elit nisi in eleifend sed nisi. Pulvinar at orci, proin imperdiet commodo consectetur convallis risus."
      }
    },
    {
      "id": "OuSX-gEsDH",
      "type": "paragraph",
      "data": {
        "text": " Sed condimentum enim dignissim adipiscing faucibus consequat, urna. Viverra purus et erat auctor aliquam. Risus, volutpat vulputate posuere purus sit congue convallis aliquet. Arcu id augue ut feugiat donec porttitor neque. Mauris, neque ultricies eu vestibulum, bibendum quam lorem id. "
      }
    },
    {
      "id": "ddv_yoT4Tf",
      "type": "paragraph",
      "data": {
        "text": "Dolor lacus, eget nunc lectus in tellus, pharetra, porttitor.Ipsum sit mattis nulla quam nulla. Gravida id gravida ac enim mauris id. Non pellentesque congue eget consectetur turpis. Sapien, dictum molestie sem tempor. Diam elit, orci, tincidunt aenean tempus. Quis velit eget ut tortor tellus. Sed vel, congue felis elit erat nam nibh orci."
      }
    },
    {
      "id": "qBhXRBkw5p",
      "type": "header",
      "data": {
        "text": "Software and tools",
        "level": 3
      }
    },
    {
      "id": "soOu623F73",
      "type": "paragraph",
      "data": {
        "text": "Mi tincidunt elit, id quisque ligula ac diam, amet. Vel etiam suspendisse morbi eleifend faucibus eget vestibulum felis. Dictum quis montes, sit sit. Tellus aliquam enim urna, etiam. Mauris posuere vulputate arcu amet, vitae nisi, tellus tincidunt. At feugiat sapien varius id.Eget quis mi enim, leo lacinia pharetra, semper. "
      }
    },
    {
      "id": "VE1DTH1miX",
      "type": "paragraph",
      "data": {
        "text": "Eget in volutpat mollis at volutpat lectus velit, sed auctor. Porttitor fames arcu quis fusce augue enim. Quis at habitant diam at. Suscipit tristique risus, at donec. In turpis vel et quam imperdiet. Ipsum molestie aliquet sodales id est ac volutpat."
      }
    },
    {
      "id": "Tcc3esDrjJ",
      "type": "header",
      "data": {
        "text": "Other resources",
        "level": 3
      }
    },
    {
      "id": "v7fSeK8jzg",
      "type": "paragraph",
      "data": {
        "text": "Sagittis et eu at elementum, quis in. Proin praesent volutpat egestas sociis sit lorem nunc nunc sit. Eget diam curabitur mi ac. Auctor rutrum lacus malesuada massa ornare et. Vulputate consectetur ac ultrices at diam dui eget fringilla tincidunt. Arcu sit dignissim massa erat cursus vulputate gravida id. "
      }
    },
    {
      "id": "faTL50wMwv",
      "type": "paragraph",
      "data": {
        "text": "Sed quis auctor vulputate hac elementum gravida cursus dis.Lectus id duis vitae porttitor enim gravida morbi.Eu turpis posuere semper feugiat volutpat elit, ultrices suspendisse. Auctor vel in vitae placerat.Suspendisse maecenas ac donec scelerisque diam sed est duis purus."
      }
    },
    {
      "id": "ES9jEfCzsD",
      "type": "list",
      "data": {
        "style": "ordered",
        "items": [
          "item 1",
          "item 2",
          "item 3"
        ]
      }
    },
    {
      "id": "MHibChwWt0",
      "type": "image",
      "data": {
        "file": {
          "url": articleImg
        },
        "caption": "Image by Kent at <a href=\"http://google.com\">Modern Angles</a>",
        "withBorder": false,
        "stretched": false,
        "withBackground": false
      }
    },
    {
      "id": "Y0AuNXd6EF",
      "type": "paragraph",
      "data": {
        "text": "Lectus leo massa amet posuere. Malesuada mattis non convallis quisque. Libero sit et imperdiet bibendum quisque dictum vestibulum in non. Pretium ultricies tempor non est diam. Enim ut enim amet amet integer cursus. Sit ac commodo pretium sed etiam turpis suspendisse at."
      }
    },
    {
      "id": "TYYBLB0WLw",
      "type": "paragraph",
      "data": {
        "text": "Tristique odio senectus nam posuere ornare leo metus, ultricies. Blandit duis ultricies vulputate morbi feugiat cras placerat elit. Aliquam tellus lorem sed ac. Montes, sed mattis pellentesque suscipit accumsan. Cursus viverra aenean magna risus elementum faucibus molestie pellentesque. Arcu ultricies sed mauris vestibulum."
      }
    },
    {
      "id": "8J50mpDsu1",
      "type": "conclusion",
      "data": {
        "text": "Morbi sed imperdiet in ipsum, adipiscing elit dui lectus. Tellus id scelerisque est ultricies ultricies. Duis est sit sed leo nisl, blandit elit sagittis. <br/><br/>Quisque tristique consequat quam sed. Nisl at scelerisque amet nulla purus habitasse.Nunc sed faucibus bibendum feugiat sed interdum. Ipsum egestas condimentum mi massa. In tincidunt pharetra consectetur sed duis facilisis metus. Etiam egestas in nec sed et. <br/><br/>Quis lobortis at sit dictum eget nibh tortor commodo cursus.Odio felis sagittis, morbi feugiat tortor vitae feugiat fusce aliquet. Nam elementum urna nisi aliquet erat dolor enim. Ornare id morbi eget ipsum. Aliquam senectus neque ut id eget consectetur dictum. Donec posuere pharetra odio consequat scelerisque et, nunc tortor."
      }
    }
  ]
}